
import React from 'react';
import ReportedQuestions from '@/components/admin/ReportedQuestions';
import QuestionManagementMenu from '@/components/admin/QuestionManagementMenu';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';

const AdminReports = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex flex-col">
      <Header />
      <div className="flex-1 container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Reported Questions</h1>
        <QuestionManagementMenu />
        <ReportedQuestions />
      </div>
      <Footer />
    </div>
  );
};

export default AdminReports;
